import declare from "dojo/_base/declare";
import Copy from "csi/table/Copy";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";

const CopyProductSKUController = declare(Copy, {

	/**
     * @override
     * Adding the AutoGTIN generation operation to the writer
     */
	_onAction(call: CallMethod) {
		if (this.m_formData.getFieldValue("AutoGTIN")) {
			this.m_writer.callMethod("SiteAdmin", "GlobalTradeItemAutoGenerateGTIN")
				.addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlNode);
		}
		this.inherited(arguments);
	},
});

export = CopyProductSKUController;